import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en';
import pt from './pt';
import fr from './fr';
import es from './es';

i18n
  .use(LanguageDetector) // Detecta automaticamente o idioma
  .use(initReactI18next) // Passa o i18n ao React-i18next
  .init({
    resources: {
      en,
      pt,
      fr,
      es
    },
  ns: ['assistantConfiguration', 'chat','common', 'database', 'hub', 'instructions', 'login', 'management', 'resource', 'updatePopup', 'errors'],   // 🔹 lista de namespaces disponíveis (inclui updatePopup e errors)
    defaultNS: 'common',              // 🔸 namespace padrão
    fallbackLng: 'en', // Idioma de fallback caso não detecte outro
    detection: {
      order: ['navigator', 'cookie', 'localStorage', 'querystring', 'sessionStorage', 'path', 'subdomain'],
      caches: ['cookie'] // Onde salvar o idioma selecionado (opcional)
    },
    interpolation: {
      escapeValue: false // React já faz a proteção contra XSS
    }
  });

export default i18n;
